import _ from 'lodash'
import { mapActions } from 'vuex'
import PrepareOfferDialog from './components/prepareOfferDialog.vue'

export default {
  components: {
    PrepareOfferDialog
  },
  data () {
    return {
      prepareOfferReview: {
        show: false,
        loading: false,
        applications: []
      },
      prepareOfferWindow: null
    }
  },
  computed: {
    hasSendOfferPermission () {
      return this.hasAnyPermission(['PREMIUM_OFFER_MANAGEMENT', 'PERM_OFFER_INITIATE'])
    },
    tableOperationList () {
      return _.filter(this.operationList, item => item.operator !== this.handleSendOfferOperation)
    }
  },
  mounted () {
    window.addEventListener('focus', this.handlePrepareOfferWindowFocus)
  },
  beforeDestroy () {
    window.removeEventListener('focus', this.handlePrepareOfferWindowFocus)
  },
  methods: {
    ...mapActions('application', ['getOfferLetterApplicationBaseInfoList']),
    handleSendOfferAction () {
      if (!this.hasSendOfferPermission || this.noAction || this.prepareOfferReview.loading || !this.hasSelected()) {
        return
      }
      const isSelectAll = this.isSelectedAllCandidate || this.isSelectedAllCardCandidate
      // 只有全选才按筛选条件查询全部申请，其他选择按申请 ID 查询。
      if (isSelectAll) {
        const filter = _.cloneDeep(this.searchParams)
        // 全选使用完整筛选结果，清除之前取消勾选留下的排除条件。
        delete filter.cancel_candidate_ids
        if (this.jobId) {
          filter.job_id = _.toString(this.jobId)
          filter.job_status = ''
        }
        return this.loadPrepareOfferReview({
          filters: filter
        })
      }
      return this.reviewPrepareOffer(this.selectedCandidateList)
    },
    handleSendOfferOperation (rowData) {
      return this.reviewPrepareOffer([rowData])
    },
    reviewPrepareOffer (applicationList) {
      if (!this.hasSendOfferPermission || this.noAction || this.prepareOfferReview.loading) {
        return
      }
      return this.loadPrepareOfferReview({
        application_ids: _.uniq(_.map(applicationList, 'id'))
      })
    },
    async loadPrepareOfferReview (params) {
      this.prepareOfferReview.show = true
      this.prepareOfferReview.loading = true
      this.prepareOfferReview.applications = []
      try {
        const applications = await this.getOfferLetterApplicationBaseInfoList(params)
        this.prepareOfferReview.applications = applications
      } finally {
        this.prepareOfferReview.loading = false
      }
    },
    openPrepareOffer (applicationList) {
      if (!this.hasSendOfferPermission || this.noAction || this.prepareOfferReview.loading) {
        return
      }
      const eligible = _.filter(applicationList, item => item.has_offer === false && item.application_id && !item.is_revoked && _.trim(item.email))
      if (_.isEmpty(eligible)) {
        return
      }
      const query = new URLSearchParams({
        application_ids: _.join(_.uniq(_.map(eligible, 'application_id')), ',')
      })
      this.prepareOfferWindow = window.open(`/recruiter-pc/v-admin/application/prepare-offer?${query}`, '_blank')
      this.prepareOfferReview.show = false
    },
    handlePrepareOfferWindowFocus () {
      if (!this.prepareOfferWindow) {
        return
      }
      const prepareOfferWindowClosed = this.prepareOfferWindow.closed
      this.handelSearch(this.search, false, this.pagination.page)
      if (prepareOfferWindowClosed) {
        this.prepareOfferWindow = null
      }
    }
  }
}
